/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WsMember } from './WsMember';
import {
    WsMemberFromJSON,
    WsMemberFromJSONTyped,
    WsMemberToJSON,
    WsMemberToJSONTyped,
} from './WsMember';

/**
 * 
 * @export
 * @interface Permission
 */
export interface Permission {
    /**
     * Unique identifier of this permission record
     * @type {string}
     * @memberof Permission
     */
    id: string;
    /**
     * The workspace member this permission is granted to
     * @type {WsMember}
     * @memberof Permission
     */
    member: WsMember;
    /**
     * The permission type granted
     * @type {string}
     * @memberof Permission
     */
    permission: PermissionPermissionEnum;
}


/**
 * @export
 */
export const PermissionPermissionEnum = {
    ManageButtons: 'MANAGE_BUTTONS',
    ManageDomain: 'MANAGE_DOMAIN',
    ChatAgent: 'CHAT_AGENT'
} as const;
export type PermissionPermissionEnum = typeof PermissionPermissionEnum[keyof typeof PermissionPermissionEnum];


/**
 * Check if a given object implements the Permission interface.
 */
export function instanceOfPermission(value: object): value is Permission {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('member' in value) || value['member'] === undefined) return false;
    if (!('permission' in value) || value['permission'] === undefined) return false;
    return true;
}

export function PermissionFromJSON(json: any): Permission {
    return PermissionFromJSONTyped(json, false);
}

export function PermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Permission {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'member': WsMemberFromJSON(json['member']),
        'permission': json['permission'],
    };
}

export function PermissionToJSON(json: any): Permission {
    return PermissionToJSONTyped(json, false);
}

export function PermissionToJSONTyped(value?: Permission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'member': WsMemberToJSON(value['member']),
        'permission': value['permission'],
    };
}

